import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-white" data-id="element-17" data-mp="bfj6p4q0ph8">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8" data-id="element-18" data-mp="3iqztf3fsgbxb">
        <SectionHeader id="beneficios" title="¿Qué puede cambiar cuando empiezas?" description="Preparar tus clases con una estructura organizada puede hacer una gran diferencia." data-id="element-19" data-mp="3npb6dn1dr2jr" />
        <ul className="mt-2.5 grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-20" data-mp="3drmxzuaupwj4">
          {benefits.map(b => {
          const Icon = b.icon;
          return <li key={b.title} className="flex gap-2.5 rounded-lg border border-navy/10 bg-mist p-2.5" data-id="element-21" data-mp="2ztf7a44errge">
                <span aria-hidden="true" className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md bg-tech text-volt" data-id="element-22" data-mp="34sjh8wz5pt7s">
                  <Icon size={16} data-id="element-23" data-mp="12wzl5dpiv7af" />
                </span>
                <div data-id="element-24" data-mp="2be49brllvf5s">
                  <h3 className="font-condensed text-sm font-bold text-navy sm:text-base" data-id="element-25" data-mp="2bdmi59dsvr4q">{b.title}</h3>
                  <p className="mt-0.5 text-[0.78rem] leading-snug text-navy/75 sm:text-sm" data-id="element-26" data-mp="27dbzox8tn88z">{b.desc}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}